import cn from "classnames";

export const StatusText = ({
  className,
  icon,
  children,
}: {
  className?: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) => (
  <div
    className={cn(
      "flex items-center gap-1 text-sm font-semibold w-fit",
      className,
    )}
  >
    <span>{children}</span>
    {icon}
  </div>
);
